import React from 'react';

/**
 * CareVisual
 * 
 * Displays the upper visual for the Care section.
 */
export const CareVisual = () => {
  return (
    <div className="il-add" data-beta-flow="true" style={{ backgroundImage: `url("/img/care/care-upper.jpeg")` }}></div>
  );
};
